// @flow
import type { Element } from 'react';

export type Icon = {
    className?: string,
    color?: string,
    height?: number,
    /** A string describing the icon if it's not purely decorative for accessibility */
    title?: string | Element<any>,
    width?: number,
};

export type TwoTonedIcon = {
    className?: string,
    height?: number,
    /** A string describing the icon if it's not purely decorative for accessibility */
    title?: string | Element<any>,
    width?: number,
};
